import { tableControlsPlugin } from './YfmTableControls';
export const YfmTableAdditions = (builder) => {
    builder.addPlugin(tableControlsPlugin);
};
